export const BRAND_NAME = "Learning Management System";
export const BRAND_SHORT_CODE = 'Brihha';
export const HELP_DESK = true;
export const TOPBAR_LOGO = true;
export const LOGIN_LOGO = true;
export const LOGIN_PAGEBEFORE = false;
export const LOGIN_PAGEAFTER = false;
export const HELPDESKURL = "https://judgeindia.atlassian.net/servicedesk/customer/portal/7"
export const COMMONERRORMESSAGE = "We encountered an unexpected error. Please try again. If the issue persists, contact the support team for assistance.";

